<template>
  <div id="user-page">
    <page-header-component icon="bi bi-person" title="Pengguna" :hide-filter="true" />
    <div class="px-2">
      <div class="bg-white rounded p-3 shade">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-8 component-header component-header-left">
                <h6>Daftar User</h6>
              </div>
              <div class="col-md-4 component-header component-header-right">
                <button v-if="isAdmin" id="tambah-user" aria-label="" v-on:click="addUser"
                  class="btn btn-warning btn-icon-left" type="button">
                  <i class="bi bi-plus"></i> <span class="">Tambah User</span>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="component-subtitle">
              <p class="m-b-15">
                Berikut merupakan daftar pengguna beserta hak aksesnya dalam
                proyek ini.
              </p>
            </div>
          </div>
          <div class="col-md-12">
            <table class="table" id="users_table">
              <thead>
                <tr>
                  <th class="text-center" style="width: 1rem !important">No</th>
                  <th>Nama</th>
                  <th>Username</th>
                  <th>Email</th>
                  <th>No Telepon</th>
                  <th>Role</th>
                  <th v-if="isAdmin" class="text-center">Aksi</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <modal-dynamic-component v-if="currentModal" :key="modal_key" :modal="currentModal" :data="modal_data"
      :static="true" />
    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }"></v-tour>
  </div>
</template>

<script>
import $ from "jquery";
import page_header from "@/views/components/page_header.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_user from "@/views/components/settings/user/modal_add_user.vue";
import modal_edit_user from "@/views/components/settings/user/modal_edit_user.vue";
import modal_change_password from "@/views/components/super-admin/detail-project/modal_change_password.vue";
import swal from "sweetalert";

var modals = {
  title: "Tambah User",
  subtitle: "Silahkan masukan detail user baru yang akan ditambahkan",
  component: modal_add_user,
};

export default {
  name: "User",
  title: "Pengaturan Pengguna | Sibernetik",
  components: {
    "page-header-component": page_header,
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      tour_steps: [],
      currentModal: null,
      modal_key: 0,
      table: null,
      isError: false,
      role: [],
      modal_data: null,
      id_project: this.$store.getters.user.id_project,
    };
  },
  methods: {
    addUser: function () {
      this.modal_key++;
      this.currentModal = modals;
    },
    getUser: function () {
      let api = process.env.VUE_APP_API_URL + "users/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 204) {
            this.users = {};
            this.isError = false;
          } else {
            this.users = response.data;
            this.isError = false;
            let btn;
            let idx;
            this.table.clear();
            let c = 1;
            for (let index in this.users) {
              idx = `<center>${c}</center>`;
              btn =
                '<center><button id="ubah-password" class="btn btn-sm btn-warning m-r-5 pass" title="Ubah Password"><i class="bi bi-person-lock"></i></button><button id="edit-user" class="btn btn-sm btn-complete m-r-5 ch"><i class="bi bi-pencil-square ch"></i></button><button id="hapus-user" class="btn btn-sm btn-danger del"><i class="bi bi-trash"></i></button></center>';
              if (this.isAdmin) {
                this.table.row
                  .add([
                    idx,
                    this.users[index].nama,
                    this.users[index].username,
                    this.users[index].email,
                    this.users[index].phone,
                    this.role[this.users[index].role],
                    btn,
                  ])
                  .node().id = index;
              } else {
                this.table.row
                  .add([
                    idx,
                    this.users[index].nama,
                    this.users[index].username,
                    this.users[index].email,
                    this.users[index].phone,
                    this.role[this.users[index].role],
                  ])
                  .node().id = index;
              }
              this.table.draw(false);
              c++;
            }
          }
        })
        .catch((err) => {
          this.resp = err.response;
          this.isError = true;
        });
    },
    deleteUser: function (index) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus user tersebut.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: this.users[index]._id.$oid,
          };
          let api = process.env.VUE_APP_API_URL + "users-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.users.splice(index, 1);
                self.table
                  .row("#" + index)
                  .remove()
                  .draw(false);
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> User berhasil dihapus.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function () {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus user.',
                  position: "top",
                  timeout: 4000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    changePassword: function (index) {
      let modal = {
        title: "Ubah Password",
        subtitle: "Silahkan masukan password baru",
        component: modal_change_password,
      };
      this.modal_data = [];
      this.modal_data["user"] = this.users[index];
      this.currentModal = modal;
      this.modal_key++;
    },
    editUser: function (index) {
      let modal = {
        title: "Edit User",
        subtitle: "Silahkan masukan detail user baru yang akan diupdate",
        component: modal_edit_user,
      };
      this.modal_data = [];
      this.modal_data[0] = this.users[index];
      this.currentModal = modal;
      this.modal_key++;
    },
  },
  computed: {
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2) {
        return true;
      }

      return false;
    },
  },
  created: function () {
    this.role[1] = "Super Admin";
    this.role[2] = "Validator";
    this.role[3] = "Analis";
    this.role[4] = "Viewer";
  },
  mounted: function () {
    this.table = $("#users_table").DataTable({
      columnDefs: [
        {
          targets: 0,
          orderable: false,
        },
        {
          targets: 6,
          orderable: false,
        },
      ],
      language: {
        search: "Cari:",
        zeroRecords: "Data tidak tersedia",
        info: "Menampilkan halaman _PAGE_ dari _PAGES_",
        infoEmpty: "Menampilkan 0 data",
        lengthMenu: "Tampilkan _MENU_ data",
        "paginate": {
          "next": "Lanjut",
          "previous": "Sebelum"
        }
      },
      pageLength: 5,
      lengthMenu: [5, 10, 25, 50, 75, 100],
      aaSorting: [[1, "desc"]],
    });
    this.getUser();
    let self = this;
    $("#users_table tbody").on("click", ".del", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.deleteUser(id);
    });
    $("#users_table tbody").on("click", ".ch", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.editUser(id);
    });
    $("#users_table tbody").on("click", ".pass", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.changePassword(id);
    });
    let v_step = [];
    v_step[0] = {
      target: "#tambah-user",
      header: {
        title: "Tombol Tambah User.",
      },
      content: `Klik untuk menambahkan data user baru.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#users_table_filter",
      header: {
        title: "Cari Item Tabel",
      },
      content: `Masukkan kata kunci untuk mencari user yang diinginkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#users_table",
      header: {
        title: "Tabel Daftar User",
      },
      content: `Menampilkan daftar user yang dapat mengakses sistem dengan role masing-masing.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#ubah-password",
      header: {
        title: "Tombol Ubah Password",
      },
      content: `Klik untuk mengubah password dari user yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#edit-user",
      header: {
        title: "Tombol Edit User",
      },
      content: `Klik untuk mengedit data user yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#hapus-user",
      header: {
        title: "Tombol Hapus User",
      },
      content: `Klik untuk menghapus data user yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    this.tour_steps = v_step;
  },
};
</script>
